// extracted by mini-css-extract-plugin
module.exports = {"dropzoneButton":"styles_dropzoneButton__LpP00"};